import { useEffect, useState } from "react";

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <>
      {visible && (
        <button
          onClick={scrollToTop}
          style={{
            position: "fixed",
            zIndex: 1000,
            bottom: "90px",
            right: "20px",
            padding: "12px 18px",
            borderRadius: "50%",
            border: "none",
            backgroundColor: "var(--tsn-orange)",
            color: "white",
            cursor: "pointer",
            fontSize: "20px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.2)"
          }}
        >
          ↑
        </button>
      )}
    </>
  );
}